<template>
  <v-layout align-end justify-end row wrap>
    <v-flex xs12>
      <v-layout
        v-if="bookingForm.loading == true"
        row
        style="width: 100%"
        justify-end
        align-end
      >
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
      <v-row
        v-if="bookingForm.loading == false"
        style="width: 100%"
        justify="space-between"
        align="center"
      >
        <v-btn
          color="#E97145"
          @click="close"
          class="text-none white--text"
          small
          >Close</v-btn
        >
        <v-flex shrink>
          <v-row class="flex-nowrap">
            <v-flex v-if="
                  !largeMode" px-1>
         
            </v-flex>
            <v-flex v-if="bookingHasOtherTrip"><p>Booking is part of a pair ({{this.bookingForm.booking.cart.outboundBookingId}}, {{this.bookingForm.booking.cart.returnBookingId}})</p></v-flex>
            <v-flex pr-2> <v-btn
              submit
              v-if="(!updateMode || updateMode == null) && !backdate && allowReturn && bookingForm.booking.outbound_booking_id == null"
              @click="bookAndReturn"
              class="text-none"
              dark
              :small="$vuetify.breakpoint.mdAndUp"
              :x-small="$vuetify.breakpoint.smAndDown"
              color="green"
              >Book and Return</v-btn
            ></v-flex>
            <v-flex px-1>
              <v-btn
                submit
                v-if="(!updateMode || updateMode == null) && !backdate"
                @click="book"
                class="text-none"
                dark
                :small="$vuetify.breakpoint.mdAndUp"
                :x-small="$vuetify.breakpoint.smAndDown"
                color="#8080FF"
                >
                Make Booking
              </v-btn>
              <v-menu
                v-if="(!updateMode || updateMode == null) && !backdate && unconfirmedBookingsEnabled"
                top
                :offset-y="true"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="text-none mx-2"
                    dark
                    :small="$vuetify.breakpoint.mdAndUp"
                    :x-small="$vuetify.breakpoint.smAndDown"
                    color="blue"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Unconfirmed
                  </v-btn>
                </template>
    
                <v-list>
                  <v-list-item>
                    <v-btn
                      class="text-none mx-2"
                      dark
                      :small="$vuetify.breakpoint.mdAndUp"
                      :x-small="$vuetify.breakpoint.smAndDown"
                      @click="bookButNotConfirmed('busy')"
                      color="purple lighten-2"
                    >
                      Unconfirmed Booking
                    </v-btn>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          small
                        >
                          mdi-information
                        </v-icon>
                      </template>
                      <span>
                          Booking can be confirmed later and we are saying that we will contact you once booking is confirmed.
                        </span>
                    </v-tooltip>
                  </v-list-item>
                  <v-list-item>
                    <v-btn
                      class="text-none mx-2"
                      dark
                      :small="$vuetify.breakpoint.mdAndUp"
                      :x-small="$vuetify.breakpoint.smAndDown"
                      @click="bookButNotConfirmed('unavailable')"
                      color="orange"
                    >
                      No Driver Available
                    </v-btn>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          small
                        >
                          mdi-information
                        </v-icon>
                      </template>
                      <span>
                          Booking can be confirmed later but we are saying we have no availability
                        </span>
                    </v-tooltip>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-btn
                submit
                v-if="(!updateMode || updateMode == null) && backdate"
                @click="backdateTrip"
                class="text-none"
                dark
                color="#8268FC"
                :small="$vuetify.breakpoint.mdAndUp"
                :x-small="$vuetify.breakpoint.smAndDown"
                >Backdate</v-btn
              >
            </v-flex>
            <v-flex v-if="cancellationFeeAmount != 0">{{(cancellationFeeAmount/100).toFixed(2)}}</v-flex>
            <v-flex v-if="
                  bookingForm.booking.state != null &&
                  bookingForm.booking.state != 'cancelled' &&
                  bookingForm.booking.state != 'completed'
                " px-1>
              <v-btn
                dark
                color="red lighten-2"
                @click="showCancel"
                class="text-none"
                :small="$vuetify.breakpoint.mdAndUp"
                :x-small="$vuetify.breakpoint.smAndDown"
                >Cancel Booking</v-btn
              >
            </v-flex>
            <v-flex 
                v-if="bookingForm.booking.state" px-1>
              <v-btn
                submit
                dark
                color="#8268FC"
                @click="update"
                class="text-none"
                :small="$vuetify.breakpoint.mdAndUp"
                :x-small="$vuetify.breakpoint.smAndDown"
                >Update Booking</v-btn
              >
            </v-flex>
            <v-flex v-if="
                  largeMode &&
                  bookingForm.booking.state != null &&
                  bookingForm.booking.state != 'accepted'
                " px-1>
              <v-btn
                dark
                color="orange"
                @click="showChangeUser"
                class="text-none"
                small
                >Change User</v-btn
              >
            </v-flex>
          </v-row>
        </v-flex>
      </v-row>
      <p style="color: red; margin-left: 18px">
        {{ bookingForm.errors.error }}
      </p>
    </v-flex>
    <v-dialog persistent v-model="cancelDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Cancel Booking</span>
        </v-card-title>
        <v-flex pa-4>
          <v-row>
            <v-flex
              v-if="bookingForm.booking.card_payment_type == 'prepaid'"
              shrink
            >
              <v-radio-group v-model="cancellationFee">
                <v-radio label="Use System Policy" :value="0"></v-radio>
                <v-radio label="Yes, Charge Cancellation Fee" :value="1"></v-radio>
                <v-radio label="No, Do NOT Charge Cancellation Fee" :value="2"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex
              v-if="bookingForm.booking.card_payment_type != 'prepaid' && bookingForm.booking.payment_type == 'card'"
              shrink
            >
              <p>Cancellation Fee</p>
              <v-radio-group v-model="cancellationFee">
                <v-radio :label="'Use System Policy'" :value="0"></v-radio>
                <v-radio label="Yes, Charge Cancellation Fee" :value="1"></v-radio>
                <v-radio label="No, Do NOT Charge Cancellation Fee" :value="2"></v-radio>
              </v-radio-group>
              <v-currency-field
                v-if="cancellationFee == 1"
                type="number"
                v-bind="currency_config"
                v-model="amount"
                min="0"
                class="small-text-field"
                single-line
                height="28"
                flat
              ></v-currency-field>
            </v-flex>
            <v-flex shrink pl-5>
              <v-checkbox
                v-if="bookingHasOtherTripToCancel"
                :label="'Cancel ' + nameForOtherTrip + ' trip'"
                v-model="cancelOtherTrip"
              ></v-checkbox>
            </v-flex>
          </v-row>
        </v-flex>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat text @click="cancelDialog = false">Back</v-btn>
          <v-btn flat text @click="cancel">Confirm Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cancelBookingDialog" width="600px">
      <CancelBooking @closeCancelDialog="cancelBookingDialog = false" @cancelled="cancelBookingDialog = false" :booking="bookingForm.booking"></CancelBooking>
    </v-dialog>
  </v-layout>
</template>

<script>
import SimpleTextAreaInput from "@/components/widget/input/SimpleTextAreaInput.vue";
import qs from "qs";
import axios from "axios";
import moment from 'moment'
import CancelBooking from '@/components/booking/CancelBooking'

axios.defaults.withCredentials = true;

export default {
  name: "BookRideOptions",
  model: {
    prop: "content",
    event: "input",
  },
  components: {
    CancelBooking,
    SimpleTextAreaInput
  },
  props: {
    allowReturn: Boolean,
    content: String,
    label: String,
    required: Boolean,
    errorMessages: Object,
    bookingForm: Object,
    updateMode: {
      type: Boolean,
      default: false,
    },
    largeMode: {
      type: Boolean,
      default: true,
    },
    backdate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      unconfirmedBookingWaitingTimeInHours: 2,
      cancelBookingDialog: false,
      menu: false,
      cancelDialog: false,
      cancellationFee: false,
      cancelOtherTrip: false,
      amount: null,
      cancellationFeeAmount: 0,
      currency_config: {
        decimal: ".",
        prefix: "£",
        precision: 2,
        masked: false,
        allowBlank: true
      },
    };
  },
  computed: {
    dispatchConfiguration () {
      return this.$store.getters['dispatch/getDispatchConfiguration']
    },
    unconfirmedBookingsConfig () {
      return (this.dispatchConfiguration ? this.dispatchConfiguration.unconfirmed_booking_configuration : null)
    },
    unconfirmedBookingsEnabled () {
      return (this.unconfirmedBookingsConfig ? this.unconfirmedBookingsConfig.enabled : false)
    },
    bookingHasOtherTrip: function() {
      if (this.bookingForm.booking.cart != null) {
        return true;
      }

      return false;
    },
    nameForOtherTrip: function () {
      if (
          this.bookingForm.booking.cart.outboundBookingId ==
          this.bookingForm.booking.id
      ) {
        return "Return";
      } else {
        return "Outbound";
      }
    },
    bookingHasOtherTripToCancel: function () {
      if (this.bookingForm.booking.cart == null) {
        return false;
      }

      if (
        this.bookingForm.booking.cart.outboundBookingId ==
        this.bookingForm.booking.id
      ) {
        if (this.bookingForm.booking.cart.returnBookingId != null) {
          if (
            this.bookingForm.booking.cart.returnState != "completed" &&
            this.bookingForm.booking.cart.returnState != "cancelled"
          ) {
            return true;
          }
        }
      } else {
        if (
          this.bookingForm.booking.cart.outboundState != "completed" &&
          this.bookingForm.booking.cart.outboundState != "cancelled"
        ) {
          return true;
        }
      }

      return false;
    },
  },
  methods: {
    isBusinessUserEntered() {
      if (this.bookingForm.booking.business_customer_email != null &&
        this.bookingForm.booking.business_customer_name != null &&
        this.bookingForm.booking.business_customer_reference != null &&
        this.bookingForm.booking.authorized_by != null) {
        return true
      }
      return false
     },
    showCancel: async function() {
      this.cancelBookingDialog = true
      

       try {
        var url = `${this.$store.state.apiUrl}/booking/getCancellationFee/${this.bookingForm.booking.id}`;

        let response = await axios.get(url, {
          params: {}
        });

        console.log(response.data);

        this.cancellationFeeAmount = response.data.cancellationFee
      } catch (error) {
        this.loadingEditBooking = false;

        console.log("Failed to get booking " + error);
        return "Unknown Error";
      }
    },
    showChangeUser: function () {
      this.$emit("change", null);
      console.log("Show change user");
    },
    expand: function () {
      this.$emit("expand", null);
    },
    close: function () {
      this.$emit("close", null);
    },
    bookAndReturn: function () {
      this.$emit("bookAndReturn", null);
    },
    book: function () {
      if (this.bookingForm.booking.payment_type == 'account' && !this.isBusinessUserEntered() ) {
        this.bookingForm.validateBusinessCustomerDetails()
        this.$snackbar.error("Please enter lead passenger details")
        return;
      }
      this.checkRideTypeCompatibility()
      // this.$emit("book", null);
    },
    checkRideTypeCompatibility() {
      if (!this.bookingForm.isSelectedRideTypeCompatible() && !this.bookingForm.rideTypeCompatibilityChecked) {
        this.$swal.fire({
          text: "You have selected incompatible ride type for the no. of passengers and luggage. ",
          icon: 'warning',
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonColor: 'rgba(76,140,98,0.78)',
          cancelButtonColor: '#e85b5b',
          denyButtonColor: '#3085d6',
          confirmButtonText: 'Yes, Book it!',
          denyButtonText: `Change Ride Type`,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$emit("book", null);
            this.$swal.fire(
              'Confirmed!',
              'The trip is now booked for customer',
              'success'
            )
          } else if (result.isDenied) {
            return;
          }
        })
      } else {
        this.$emit("book", null);
      }
      this.bookingForm.rideTypeCompatibilityChecked = true
    },
    bookButNotConfirmed: function (availabilityStatus) {
      if (this.bookingForm.booking.payment_type == 'account' && !this.bookingForm.user.business && !this.isBusinessUserEntered() ) {
        this.bookingForm.validateBusinessCustomerDetails()
        this.$snackbar.error("Please enter lead passenger details")
        return;
      }
      
      if (availabilityStatus == 'busy' && moment(this.bookingForm.booking.pickup_date + " " + this.bookingForm.booking.pickup_time,
        "YYYY-MM-DD HH:mm").isBefore(moment().add(this.unconfirmedBookingWaitingTimeInHours, 'hours'))) {
        this.$snackbar.error('Pickup time for unconfirmed booking should be after ' + moment().add(this.unconfirmedBookingWaitingTimeInHours,'hours').format('DD-MM-YYYY HH:mm'))
        return false
      }
      
      this.bookingForm.booking.availability_status = availabilityStatus
      this.$emit("bookUnconfirmed", null);
    },
    backdateTrip: function () {
      this.$emit("backdate", null);
    },
    update: function () {
      this.$emit("update", null);
    },
    cancel: function () {

      if (this.cancellationFee != 1) {
        this.amount = null;
      }

      if (this.cancellationFee == 1 && this.amount == null) {
        alert("Please enter a fee")
        return;
      }

      this.cancelDialog = false;
      this.$emit("cancel", {
        cancellationFee: this.cancellationFee,
        cancelOtherTrip: this.cancelOtherTrip,
        amount: this.amount
      });
    },
    clear: function () {
      this.bookingForm.clear();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
